<template>
  <Modal
    :id="'cmp_booking_booking_add_invoice_line'"
    @cancelled="onCancelClick"
  >
    <template slot="header"> {{$t('add_invoice_lines')}} </template>
    <template slot="body">
      <div class="form-group">
        <Dropdown
          class="dt-dropdown"
          :selected="selectedGroup"
          :options="invoice_itemgroups"
          :placeholder="$t('select_invoice_group')"
          box
          v-on:selectedChange="
            (e) => onDropdownChange('invoice_itemgroups', e)
          "
          :listHeight="250"
        ></Dropdown>
        <Dropdown
          class="dt-dropdown"
          :selected="selectedItem"
          :options="invoice_items"
          :placeholder="$t('select_invoice_line')"
          box
          v-on:selectedChange="
            (e) => onDropdownChange('invoice_items', e)
          "
          :listHeight="250"
        ></Dropdown>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick">
        {{$t('close')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import { BookingService } from "../../services/booking-service";

import Modal from "../../../../dt-plugins/modal/modal";
import { createTV } from "../../../../models/text-value.model";

export default {
  components: {
    Modal,
  },
  props: {
    calendarDateId: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      invoice_itemgroups: [],
      invoice_items: [],
      selectedGroup: null,
      selectedItem: null,
    };
  },
  mounted: function () {
    BookingService.findInvoiceLineForm({
      calendarDateId: this.calendarDateId,
    }).then((res) => {
      this.invoice_itemgroups = res.data.invoice_itemgroups
        .map((e) => ({
          ...e,
          text: e.group_name,
          value: e.group_name,
        }))
        .filter((e) => e.group_name);
      this.invoice_items = createTV(
        res.data.invoice_items,
        "item_name",
        "invoice_item_id"
      );
      console.log(this.invoice_itemgroups);
    });
  },
  methods: {
    onCancelClick: function (event) {
      this.$emit("cancelled", true);
    },
    onDropdownChange: function (e, item) {
      console.log(e, item);
      switch (e) {
        case "invoice_itemgroups": {
          this.selectedGroup = item;
          BookingService.insertInvoiceLineItemGroup(
            item.value,
            this.calendarDateId
          ).then((res) => {
            this.doneAddInvoiceLine(res);
          });
          break;
        }
        case "invoice_items": {
          this.selectedItem = item;
          BookingService.insertInvoiceLineItem({
            invoiceItemId: item.value,
            calendarDateId: this.calendarDateId,
          }).then((res) => {
            this.doneAddInvoiceLine(res);
          });
          break;
        }
      }
    },
    doneAddInvoiceLine: function (res) {
      this.$emit("done", res);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
